module.exports = __webpack_public_path__ + "img/main-logo.6ae1af9e.png";